export const appConfig = {
  name: "ApiFrom",
  author: "Matteo Ricupero",
  domainName: "apifrom.com",
  analyticsWebsiteId: "",
  appStoreUrl: null,
  playStoreUrl: null,
};
